// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-list .message-list__divider{position:relative}.message-list .message-list__divider hr{margin:12px 32px;border-color:rgba(0,10,30,.04)}.message-list .message-list__divider .message-list__divider-message-inner{top:-8px;left:0;right:0;position:absolute;text-align:center}.message-list .message-list__divider p{background:#fff;padding:0 8px;display:inline-block;z-index:2;color:rgba(0,10,30,.6);font-weight:500}", ""]);
// Exports
module.exports = exports;
